<template>
    <div>
        <h6 v-if="showTitle">
            Professional Licenses
            <b-button size="sm" variant="info" title="Add a License" v-on:click="newLicense" v-if="editMode"><i class="fa fa-plus-circle"></i> License</b-button>
        </h6>

        <template v-if="editMode">
            <div class="alert alert-info">Click the Add License button above to list details and provide copies of your company's professional, contractor, trade licenses and certifications.</div>
        </template>

        <sub-license-modal ref="subLicenseModal" :subcontractorId="subcontractorId" :enableOtherLicense="enableOtherLicense" />

        <template v-if="licenses.length == 0">
            -- No Professional Licenses Added --
        </template>
        <template v-else>
            <b-table bordered striped hover small responsive :items="licenses" :fields="fields">
                <template v-slot:cell(sub_license_id)="data">
                    <button type="button" class="btn btn-sm btn-link" v-on:click="editLicense(data.item)" title="Edit License"><i class="fa fa-edit"></i></button>
                    <button type="button" class="btn btn-sm btn-link text-danger" v-on:click="deleteLicense(data.item)" title="Delete License"><i class="fa fa-trash"></i></button>
                </template>

                <template v-slot:cell(license_name)="data">
                    <template v-if="data.item.license_name">{{ data.item.license_name }}</template>
                    <template v-if="data.item.other_license_name">{{ data.item.other_license_name }}</template>
                </template>

                <template v-slot:cell(files)="data">
                    <template v-for="file in data.unformatted">
                        <div class="mb-2">
                            <div>{{ file.file_name }}</div>
                            <span v-if="!file.download_only && !printMode">
                                <a :href="`/files/view/${file.file_id}`" target="_blank">View</a>&nbsp;|
                            </span>
                            <span v-if="!printMode">
                                <a :href="`/files/download/${file.file_id}`" target="_blank">Download</a>
                            </span>
                            <span v-if="!printMode && editMode">
                                |&nbsp;<a href="javascript:void(0)" @click="deleteFile(data.item.sub_license_id, file.file_id)" class="text-danger">Delete</a>
                            </span>
                        </div>
                    </template>
                </template>
            </b-table>
        </template>
    </div>
</template>

<script>
    export default {
        props: {

            editMode: {
                type: Boolean,
                default: false,
            },

            subcontractorId: {
                type: Number,
                required: true,
            },

            printMode: {
                type: Boolean,
                required: false,
                default: false,
            },

            showTitle: {
                type: Boolean,
                default: true,
            },

            enableOtherLicense: {
                type: Boolean,
                default: false,
            },

        },

        data: function() {
            return {
                licenses: this.$store.state.subcontractor.licenses,
            }
        },

        computed: {
            fields(){
                //Check for edit mode
                if(this.editMode)
                {
                    return [
                        {key: 'sub_license_id', label: 'Actions'},
                        {key: 'license_name', label: 'License'},
                        {key: 'license_number', label: 'License#'},
                        {key: 'state_code', label: 'State'},
                        {key: 'files', label: 'Copy of License'}
                    ];
                }

                return [
                    {key: 'license_name', label: 'License'},
                    {key: 'license_number', label: 'License#'},
                    {key: 'state_code', label: 'State'},
                    {key: 'files', label: 'Copy of License'}
                ];
            }
        },

        methods: {
            deleteFile(id, file_id) {
                this.$http.post(`files/delete/${file_id}`)
                .then(response => {
                    this.$toastr.success('License File Removed');
                    for (let i = 0; i < this.licenses.length; i++)
                    {
                        if (this.licenses[i].sub_license_id == id)
                        {
                            this.licenses[i].files = [];
                            this.$store.commit('setLicenses', this.licenses);
                        }
                    }
                })
            },

            newLicense(){
                //Set the license
                this.$refs.subLicenseModal.setModel({state_id: null, license_id: null});

                //Activate the modal
                this.$refs.subLicenseModal.showModal();
            },

            editLicense(license){
                //Set the license
                this.$refs.subLicenseModal.setModel(license);

                //Activate the modal
                this.$refs.subLicenseModal.showModal();
            },

            deleteLicense(license){
                //Check for confirm
                if(!confirm('Are you sure you want to delete this license?'))
                {
                    return;
                }

                //Send it
                this.$http
                    .post('/subcontractors/license/delete/' + license.sub_license_id)
                    .then(response => {
                        //Alert
                        this.$toastr.success('License Deleted');

                        //Delete the bid
                        this.$store.commit('deleteLicense', license);
                        //this.updateLicenses(license, true);
                    });
            },
        },

        mounted() {

        }
    }
</script>